var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2168_8239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.2727 10.9091C30.2909 10.9091 32.7091 8.47273 32.7091 5.45455C32.7091 2.43636 30.2909 0 27.2727 0C24.2545 0 21.8182 2.43636 21.8182 5.45455C21.8182 8.47273 24.2545 10.9091 27.2727 10.9091ZM12.7273 10.9091C15.7455 10.9091 18.1636 8.47273 18.1636 5.45455C18.1636 2.43636 15.7455 0 12.7273 0C9.70909 0 7.27273 2.43636 7.27273 5.45455C7.27273 8.47273 9.70909 10.9091 12.7273 10.9091ZM12.7273 14.5455C8.49091 14.5455 0 16.6727 0 20.9091V25.4545H25.4545V20.9091C25.4545 16.6727 16.9636 14.5455 12.7273 14.5455ZM27.2727 14.5455C26.7455 14.5455 26.1455 14.5818 25.5091 14.6364C27.6182 16.1636 29.0909 18.2182 29.0909 20.9091V25.4545H40V20.9091C40 16.6727 31.5091 14.5455 27.2727 14.5455Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2168_8239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 25.4545
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeCategory);
export default __webpack_public_path__ + "static/media/EmployeeCategory.57c2d6422fb894a89103c2790e70ac0b.svg";
export { ForwardRef as ReactComponent };